import { defaultNotificationOptionsSettingValue } from '../../../../../../backend/config/settings/NotificationOptionsDefaultValue';
import { defaultFeatureFlags } from '../../../../../../backend/config/settings/featureFlags';
import { parseISO } from 'date-fns';
// TODO write unit tests for this function
export function mapToAlertWizardFormData(alert, alertConfig, type) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    const deliveryMethods = alertConfig.availableChannels && alertConfig.availableChannels.length > 0 ? alertConfig.availableChannels : [];
    const channels = alert.channels.filter((channel) => ['inbox', ...deliveryMethods].includes(channel));
    // If Template/Draft does not have mandatory channel set, we forcefully set it here
    if (!type || type === 'template' || type === 'draft') {
        const mandatoryChannels = (alertConfig === null || alertConfig === void 0 ? void 0 : alertConfig.notificationOptions) && alertConfig.notificationOptions.mandatoryChannels
            ? alertConfig.notificationOptions.mandatoryChannels
            : defaultNotificationOptionsSettingValue.mandatoryChannels;
        mandatoryChannels.forEach((channel) => {
            if (!channels.includes(channel)) {
                channels.push(channel);
            }
        });
    }
    const features = (alertConfig === null || alertConfig === void 0 ? void 0 : alertConfig.features) ? alertConfig === null || alertConfig === void 0 ? void 0 : alertConfig.features : defaultFeatureFlags.notifications;
    return {
        id: alert.id,
        channels: channels,
        deliveryOrder: {
            deliveryMode: alert.deliveryMode || 'blast',
            textDelay: getChannelDelay('sms', (_a = alert.settings) === null || _a === void 0 ? void 0 : _a.escalationDelay),
            voiceDelay: getChannelDelay('voice', (_b = alert.settings) === null || _b === void 0 ? void 0 : _b.escalationDelay),
        },
        ownerId: alert.ownerId,
        emailAttachments: alert.emailAttachments ? alert.emailAttachments : undefined,
        recipients: ((_c = alert.additionalData) === null || _c === void 0 ? void 0 : _c.recipients)
            ? filterRecipientsByAlertConfig(JSON.parse(alert.additionalData.recipients), alertConfig)
            : {},
        allowResponse: alert.responseOptions.length > 0,
        responseOptions: alert.responseOptions,
        sendDateTime: alert.sendDateTime ? parseISO(alert.sendDateTime) : undefined, // TODO this is most likely bad, we should not use Date object in form data
        subject: alert.subject,
        sendType: alert.sendDateTime ? 'schedule' : 'immediately',
        type: type || 'draft',
        voiceOptions: {
            repeatTimes: (_d = alert.settings) === null || _d === void 0 ? void 0 : _d.voiceRepeatCount,
            waitTime: (_e = alert.settings) === null || _e === void 0 ? void 0 : _e.voiceRepeatDelay,
        },
        textMessage: alert.textMessage,
        voiceMessage: alert.voiceMessage,
        voiceMessageType: alert.voiceMessageType,
        voiceRecordings: alert.voiceRecordings,
        emailCc: features.emailCc ? alert.emailCc : undefined,
        htmlMessage: alert.htmlMessage,
        messageType: alert.messageType, // TODO
        validityInHours: alert.validityInHours,
        title: alert.title,
        icon: alert.icon,
        color: alert.color,
        pinned: alert.pinned,
        permissions: (_f = alert.permissions) !== null && _f !== void 0 ? _f : [],
        phin: features.showPhin ? !!alert.phin : undefined,
        phinOptions: features.showPhin ? alert.phin : undefined,
        customAlertData: ((_g = alert.additionalData) === null || _g === void 0 ? void 0 : _g.customAlertData) != null ? JSON.parse(alert.additionalData.customAlertData) : undefined,
        followUp: ((_h = alert.additionalData) === null || _h === void 0 ? void 0 : _h.followUp) != null ? JSON.parse(alert.additionalData.followUp) : undefined,
        additionalData: alert.additionalData
            ? Object.fromEntries(Object.entries(alert.additionalData).filter(([key]) => key !== 'recipients' && key !== 'customAlertData' && key !== 'followUp'))
            : undefined,
    };
}
function getChannelDelay(channel, escalationDelay) {
    var _a;
    return escalationDelay ? (_a = escalationDelay.find((delay) => delay.channel === channel)) === null || _a === void 0 ? void 0 : _a.delay : undefined;
}
function filterRecipientsByAlertConfig(recipients, alertConfig) {
    const recipientsData = Object.assign({}, recipients);
    const features = (alertConfig === null || alertConfig === void 0 ? void 0 : alertConfig.features) ? alertConfig === null || alertConfig === void 0 ? void 0 : alertConfig.features : defaultFeatureFlags.notifications;
    if (!features.enableExternalRecipients && recipients.external) {
        delete recipientsData.external;
    }
    return recipientsData;
}
